import PropTypes from 'prop-types'
import React from 'react'

export default function ImageInput({
  all, index, item, onChange
}) {

  const checked = (item.type || item.pivot && item.pivot.type) === 'banner'

  const disabled = !!(all || []).filter((currentEntry) => {
    return currentEntry.type === 'banner'
    || (currentEntry.pivot && currentEntry.pivot.type === 'banner')
  }).length

  return (
    <div
      className="form-group"
    >
      <label
        htmlFor={`images-${index}-type`}
        className="small"
      >
        <input
          type="checkbox"
          className="form-control"
          id={`images-${index}-type`}
          name="type"
          value="banner"
          // defaultChecked={checked}
          checked={checked}
          onChange={onChange}
          // disable if this is NOT checked, but another item is
          disabled={!checked && disabled}
        />
        <span>als Bannerbild verwenden</span>
      </label>
    </div>
  )

}

ImageInput.propTypes = {
  all: PropTypes.array,
  index: PropTypes.number,
  item: PropTypes.object,
  onChange: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/shared/components/ImageInput.js